"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientPage/ConsentSection.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);










var _consent = require('shared/services/consent');

var _components = require('web/screens/Directory/components');







// "Consent · Consented", then how and when, who else the phone covers, and
// Record consent. Part of the Texting rows.
const ConsentRowView = ({ consent, onRecord }) => {
  const detail = _consent.consentMethodDetail.call(void 0, consent)
  const sharedWith = _consent.consentSharedWithCopy.call(void 0, consent)
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", 'data-testid': "patient-consent-state", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
        , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}},  _consent.CONSENT_LABEL )
        , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}},  _consent.consentStatusLabel.call(void 0, consent.Status) )
      )
      ,  (!!detail || !!sharedWith || !!consent.Waiting || !!onRecord) && (
        _react2.default.createElement('div', { className: "directory-page--consent", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
          ,  !!detail && _react2.default.createElement('span', { className: "directory-page--consent--detail", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}},  detail ) 
          ,  !!sharedWith && _react2.default.createElement('span', { className: "directory-page--consent--detail", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}},  sharedWith ) 
          ,  !!consent.Waiting && (
            _react2.default.createElement('span', { className: "directory-page--consent--detail", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
              ,  `${consent.Waiting} ${consent.Waiting === 1 ? 'message waits' : 'messages wait'} for consent` 
            )
          )
          ,  onRecord && (
            _react2.default.createElement('div', { className: "directory-page--sms-actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
              , _react2.default.createElement(_components.InfoBtn, { label: _consent.RECORD_CONSENT_LABEL, onClick: onRecord, iconSrc: "/assets/icons/tick-grey.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}} )
            )
          )
        )
      )
    )
  )
}

 const ConsentRow = _react.memo.call(void 0, ConsentRowView); exports.ConsentRow = ConsentRow





// Each consent event, newest first: what happened, who did it, when.
const ConsentHistoryView = ({ consent }) => {
  if (!consent.History.length) return null
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "directory-page--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}},  _consent.CONSENT_HISTORY_TITLE )
      , _react2.default.createElement('div', { className: "directory-page--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
        , _react2.default.createElement('ul', { className: "directory-page--consent-history", 'aria-label': _consent.CONSENT_HISTORY_TITLE, __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
          ,  consent.History.map((event, i) => {
            const view = _consent.describeConsentEvent.call(void 0, event)
            return (
              _react2.default.createElement('li', { key: `${i}-${event.At}`, className: "directory-page--consent-history--item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
                , _react2.default.createElement('span', { className: "directory-page--consent-history--what", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}},  view.what )
                , _react2.default.createElement('span', { className: "directory-page--consent-history--meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
                  ,  [view.who, view.when].filter(Boolean).join(' · ') 
                )
                ,  !!view.note && _react2.default.createElement('span', { className: "directory-page--consent-history--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}},  `"${view.note}"` ) 
              )
            )
          })
        )
      )
    )
  )
}

 const ConsentHistory = _react.memo.call(void 0, ConsentHistoryView); exports.ConsentHistory = ConsentHistory
